import { GetManyQueryDto } from '../../../classes/common';
import { PartialType } from '../../../utils';
export class GetManyDispatchAreasQueryDto extends PartialType(GetManyQueryDto) {
}
